import React from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
type PageShellProps = {
  title: React.ReactNode;
  intro: string;
  image: string;
  imageAlt: string;
  children: React.ReactNode;
};
export function PageShell({
  title,
  intro,
  image,
  imageAlt,
  children
}: PageShellProps) {
  return <div className="min-h-screen w-full bg-cream" data-id="element-193" data-mp="38gzeb7vbp31v">
      <section className="p-3 md:p-5" data-id="element-194" data-mp="38ffz7kleky1o">
        <div className="relative overflow-hidden rounded-[28px] md:rounded-[36px]" data-id="element-195" data-mp="1pi2ge46s20">
          <img src={image} alt={imageAlt} className="absolute inset-0 h-full w-full object-cover" data-id="element-196" data-mp="50sgvj3i421j" />
          <div className="absolute inset-0 bg-navy-deep/50" aria-hidden="true" data-id="element-197" data-mp="3m9p3tma28q3q" />
          <div className="relative mx-auto flex min-h-[520px] max-w-[1320px] flex-col px-4 pb-12 pt-4 md:min-h-[580px] md:px-10 md:pb-16 md:pt-6" data-id="element-198" data-mp="3r8a5zr8vhjut">
            <Header data-id="element-199" data-mp="2at8vse0u5bqw" />
            <div className="mt-auto pt-20" data-id="element-200" data-mp="2aspemzj0erdx">
              <h1 className="max-w-4xl font-serif text-5xl leading-[1.04] text-cream md:text-7xl lg:text-[88px]" data-id="element-201" data-mp="2ftmtp38q35b7">{title}</h1>
              <p className="mt-6 max-w-xl text-lg leading-relaxed text-cream/90" data-id="element-202" data-mp="dc9vwzw2fffd">{intro}</p>
            </div>
          </div>
        </div>
      </section>
      <main data-id="element-203" data-mp="8ei2g1frvl92">{children}</main>
      <Footer data-id="element-204" data-mp="mcg90knuqde0" />
    </div>;
}